import { InputLabel, MenuItem, SelectChangeEvent } from '@mui/material';
import { memo, useEffect, useMemo } from 'react';
import { __TOPONYMY_API_URL__ } from 'shell/constants/environment';
import { ItemVM } from 'shell/view-models/item';
import { useHttpFetch } from 'shell/hooks/use-old-http-fetch';
import { HttpResponseList } from 'shell/models/http-response';
import { ListItemType } from 'shell/models/item-type';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';
import { PmiSelect } from 'shell/components/shared/pmi-select';

interface UrbanAreaProps {
  disabled?: boolean;
  value: string;
  onChange: (event: SelectChangeEvent<string>) => void;
  id?: string;
}

const UrbanAreaComponent = ({
  disabled,
  onChange,
  value,
  id = 'urbanArea',
}: UrbanAreaProps): React.ReactElement => {
  const {
    data,
    error,
    get: getUrbanArea,
  } = useHttpFetch<HttpResponseList<ListItemType>>(
    `${__TOPONYMY_API_URL__}/areaCircolazione/civico/tipo/zona-urbanistica`,
    {
      data: {
        payload: {
          list: [],
        },
      },
    }
  );

  const urbanAreas: Array<ItemVM> = useMemo(() => {
    if (!!error || !data?.payload) {
      return [];
    }
    return data?.payload.list.map((urbanArea) => ({
      id: urbanArea.key,
      value: urbanArea.descrizione,
    }));
  }, [data, error]);

  useEffect(() => {
    getUrbanArea();
  }, []);

  return (
    <PmiFormControl fullWidth>
      <InputLabel id={`${id}-label`} disabled={disabled}>
        Zona Urbanistica
      </InputLabel>
      <PmiSelect
        labelId={`${id}-label`}
        id={id}
        name={id}
        value={value}
        label="Zona Urbanistica"
        onChange={onChange}
        disabled={disabled}
      >
        <MenuItem value="">&nbsp;</MenuItem>
        {(urbanAreas || [])?.map((urbanArea: ItemVM) => (
          <MenuItem key={urbanArea.id} value={urbanArea.id}>
            {urbanArea.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

UrbanAreaComponent.displayName = 'Urban Area component';

const UrbanArea = memo(UrbanAreaComponent);

export default UrbanArea as typeof UrbanAreaComponent;
